export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
    },
    // {
    //   name: 'users',
    //   displayName: 'menu.users',
    //   meta: {
    //     icon: 'group',
    //   },
    // },
    // {
    //   name: 'projects',
    //   displayName: 'menu.projects',
    //   meta: {
    //     icon: 'folder_shared',
    //   },
    // },
    // {
    //   name: 'payments',
    //   displayName: 'menu.payments',
    //   meta: {
    //     icon: 'credit_card',
    //   },
    //   children: [
    //     {
    //       name: 'payment-methods',
    //       displayName: 'menu.payment-methods',
    //     },
    //     {
    //       name: 'pricing-plans',
    //       displayName: 'menu.pricing-plans',
    //     },
    //     {
    //       name: 'billing',
    //       displayName: 'menu.billing',
    //     },
    //   ],
    // },
    // {
    //   name: 'auth',
    //   displayName: 'menu.auth',
    //   meta: {
    //     icon: 'login',
    //   },
    //   children: [
    //     {
    //       name: 'login',
    //       displayName: 'menu.login',
    //     },
    //     {
    //       name: 'signup',
    //       displayName: 'menu.signup',
    //     },
    //     {
    //       name: 'recover-password',
    //       displayName: 'menu.recover-password',
    //     },
    //   ],
    // },

    {
      name: 'faq',
      displayName: 'faq',
      meta: {
        icon: 'quiz',
      },
      children: [
        {
          name: 'getting_started',
          displayName: 'getting_started',
        },
        {
          name: 'users',
          displayName: 'users',
          children: [
            {
              name: 'users_features',
              displayName: 'users_features',
            },
            {
              name: 'add_devices',
              displayName: 'add_devices',
            },
            {
              name: 'personal_acc',
              displayName: 'personal_acc',
            },
          ],
        },
        {
          name: 'groups',
          displayName: 'groups',
          children: [
            {
              name: 'groups_examples',
              displayName: 'groups_examples',
            },
          ],
        },
        {
          name: 'phone_numbers',
          displayName: 'phone_numbers',
          children: [
            {
              name: 'incoming_route_work_hours',
              displayName: 'incoming_route_work_hours',
            },
            {
              name: 'incoming_route_nums',
              displayName: 'incoming_route_nums',
            },
            {
              name: 'incoming_route_alg',
              displayName: 'incoming_route_alg',
            },
            {
              name: 'auto_attendant',
              displayName: 'auto_attendant',
            },
          ],
        },
        {
          name: 'call_records',
          displayName: 'call_records',
        },
        {
          name: 'devices',
          displayName: 'devices',
        },
        {
          name: 'voice_mail',
          displayName: 'voice_mail',
        },
        {
          name: 'fax',
          displayName: 'fax',
        },
        {
          name: 'statistics',
          displayName: 'statistics',
        },
        {
          name: 'service_codes',
          displayName: 'service_codes',
          children: [
            {
              name: 'call_transfer',
              displayName: 'call_transfer',
            },
            {
              name: 'control_by_device',
              displayName: 'device_features',
            },
            {
              name: 'parking',
              displayName: 'parking',
            },
            {
              name: 'call_pickup',
              displayName: 'call_pickup',
            },
          ],
        },
        {
          name: 'integrations',
          displayName: 'integrations',
          children: [
            {
              name: 'B24',
              displayName: 'B24',
            },
          ]
        },
      ],
    },
    // {
    //   name: '404',
    //   displayName: 'menu.404',
    //   meta: {
    //     icon: 'vuestic-iconset-files',
    //   },
    // },
    // {
    //   name: 'preferences',
    //   displayName: 'menu.preferences',
    //   meta: {
    //     icon: 'manage_accounts',
    //   },
    // },
    // {
    //   name: 'settings',
    //   displayName: 'menu.settings',
    //   meta: {
    //     icon: 'settings',
    //   },
    // },
  ] as INavigationRoute[],
}
